import { BaseProperties } from "./base.interface";
import { TagsOutput } from "./tags";

export enum ExpensesPaymentDetailsMethod {
  PIX = "PIX",
  CASH = "CASH",
  CREDIT_CARD = "CREDIT_CARD",
  DEBIT_CARD = "DEBIT_CARD",
  ZELLE = "ZELLE",
}

interface ExpensePaymentDetails {
  method: ExpensesPaymentDetailsMethod;
  paymentDate: Date;
  amount: number;
}

export interface ExpensesInput {
  name: string;
  expenseDate: Date;
  tags?: string[];
  paymentDetails?: ExpensePaymentDetails[];
}

export interface ExpensesOutput
  extends BaseProperties,
    Omit<ExpensesInput, "tags"> {
  totalPaid: number;
  tags?: string[] | TagsOutput[];
}

export interface ExpensesQueryParams {
  query?: string;
  tags?: string[];
  startDate?: string;
  endDate?: string;
  expand?: string[];
}

export const expensesPaymentDetailsMethodTranslations: Record<
  ExpensesPaymentDetailsMethod,
  string
> = {
  [ExpensesPaymentDetailsMethod.CASH]: "Dinheiro",
  [ExpensesPaymentDetailsMethod.PIX]: "PIX",
  [ExpensesPaymentDetailsMethod.CREDIT_CARD]: "Cartão de crédito",
  [ExpensesPaymentDetailsMethod.DEBIT_CARD]: "Cartão de débito",
  [ExpensesPaymentDetailsMethod.ZELLE]: "Zelle",
};
